export interface NavItem {
    name: string;
    icon: string;
    activeIcon?: string;
    route: string;
    href?: string;
    locked?: boolean;
    textClass?: string;
    badge?: string;
    children?: NavItem[];
    expanded?: boolean;
}

/**
 * Nav items shown BEFORE onboarding is completed.
 * AI Center is a single item pointing to /onboarding.
 * AI Agents is not accessible.
 */
export const NAV_ITEMS_PRE_ONBOARDING: NavItem[] = [
    {
        name: 'AI Center',
        icon: 'dr-icon-genius-sparks ai-color',
        route: '/onboarding',
        textClass: 'ai-color',
    },
    {
        name: 'Reporting',
        icon: 'dr-icon-navbar-reporting-line',
        activeIcon: 'dr-icon-navbar-reporting-fill',
        route: '/reporting',
        locked: true,
    },
    {
        name: 'Planning',
        icon: 'dr-icon-navbar-planning-line',
        activeIcon: 'dr-icon-navbar-planning-fill',
        route: '/planning',
        locked: true,
    },
    {
        name: 'Cash',
        icon: 'dr-icon-navbar-cash-line',
        activeIcon: 'dr-icon-navbar-cash-fill',
        route: '/cash',
        locked: true,
    },
    {
        name: 'Month-End Close',
        icon: 'dr-icon-navbar-month-end-close-line',
        activeIcon: 'dr-icon-navbar-month-end-close-fill',
        route: '/month-end-close',
        locked: true,
    },
    {
        name: 'Spend Control',
        icon: 'dr-icon-navbar-spend-control-line',
        activeIcon: 'dr-icon-navbar-spend-control-fill',
        route: '/spend-control',
        locked: true,
    },
];

/**
 * Nav items shown AFTER onboarding is completed.
 * AI Center becomes a group containing Datarails Agents (AI Agents).
 * Onboarding is no longer accessible.
 */
export const NAV_ITEMS_POST_ONBOARDING: NavItem[] = [
    {
        name: 'AI Center',
        icon: 'dr-icon-genius-sparks ai-color',
        route: '/ai-agents',
        textClass: 'ai-color',
        children: [
            {
                name: 'FinanceOS Agents',
                icon: 'dr-icon-navbar-agents-line',
                activeIcon: 'dr-icon-navbar-agents-fill',
                route: '/ai-agents',
                badge: 'Lite',
            },
            {
                name: 'Claude Connector',
                icon: 'dr-icon-right-pane-integration',
                route: '/claude-connector',
            },
            {
                name: 'ChatGPT Connector',
                icon: 'dr-icon-right-pane-integration',
                route: '/chatgpt-connector',
            },
            {
                name: 'Lovable Connector',
                icon: 'dr-icon-right-pane-integration',
                route: '/lovable-connector',
            },
        ],
    },
    {
        name: 'Reporting',
        icon: 'dr-icon-navbar-reporting-line',
        activeIcon: 'dr-icon-navbar-reporting-fill',
        route: '/reporting',
        locked: true,
    },
    {
        name: 'Planning',
        icon: 'dr-icon-navbar-planning-line',
        activeIcon: 'dr-icon-navbar-planning-fill',
        route: '/planning',
        locked: true,
    },
    {
        name: 'Cash',
        icon: 'dr-icon-navbar-cash-line',
        activeIcon: 'dr-icon-navbar-cash-fill',
        route: '/cash',
        locked: true,
    },
    {
        name: 'Month-End Close',
        icon: 'dr-icon-navbar-month-end-close-line',
        activeIcon: 'dr-icon-navbar-month-end-close-fill',
        route: '/month-end-close',
        locked: true,
    },
    {
        name: 'Spend Control',
        icon: 'dr-icon-navbar-spend-control-line',
        activeIcon: 'dr-icon-navbar-spend-control-fill',
        route: '/spend-control',
        locked: true,
    },
];

/**
 * Route path segments for all locked nav items.
 * Used by app-routing to generate promotion page routes.
 */
export const LOCKED_ROUTE_SEGMENTS: string[] = NAV_ITEMS_PRE_ONBOARDING.filter(item => item.locked).map(item =>
    item.route.replace(/^\//, ''),
);
